<template>
  <v-checkbox
    v-model="content"
    primary
    class="checkbox-center"
    @change="updateValue"
    hide-details />
</template>

<script>
  export default {
    name: "check-box",
    data() {
      return {
        content: this.value
      }
    },
    props: {
      value: {
        type: Number,
        default: ()=>{
          return 0
        }
      },
      keyName: {
        type: String,
        default: ()=>{
          return ''
        }
      },
      id: {
        type: Number,
        default: ()=>{
          return 0
        }
      },
    },
    methods: {
      updateValue() {
        let obj = {}
        obj.id = this.id
        obj[this.keyName] = this.content
        this.$emit('changeInput',obj)
      }
    }
  }
</script>

<style lang="scss">
  .v-datatable .v-input--selection-controls {
    justify-content: center;
  }
</style>
